<template>
  <div class="box-top">
    <MyApplicationList />
  </div>
</template>
<script type="es6">
import MyApplicationList from './components/myApplicationList.vue';
// import eventBus from '../../../../libs/eventBus';
export default {
  data () {
    return {

    };
  },
  components: {
    MyApplicationList
  },
  computed: {},
  methods: {

  },
  mounted () {
  }
};
</script>
<style lang="scss" scoped>
.box-top{
  background-color: #fff;
  padding: 15px 20px;
}
</style>
